export default __webpack_public_path__ + "static/media/cert-general-staff-cpttm-sc.f3aa1f00.jpg";